import PaymentRequestList from "@/controllers/payment/payment-request-list.js";

export default {
  extends: PaymentRequestList,
};
